module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB5001-af31f495836a356ca75127469b8a70f4.png";